/** Playback registry id for the verify-match broadcast player instance. */
export const VERIFY_MATCH_BROADCAST_PLAYBACK_ID = 'verify-match-broadcast';
